import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

interface SwitchProps {
    disabled?: boolean;
    checked?: boolean;

    onChanged?: (checked: boolean) => void;
}

const Switch: React.FC<SwitchProps> = ({
    disabled = false,
    checked = false,
    onChanged = () => {},
}) => {
    const [isOn, setIsOn] = useState(false);

    useEffect(() => {
        setIsOn(checked);
        onChanged(checked);
    }, [checked]);

    const toggleSwitch = () => {
        if (!disabled) {
            setIsOn(!isOn);
        }
    };

    return (
        <div className="flex items-center">
            <button
                className={clsx(
                    'flex h-[20px] w-[36px] cursor-pointer items-center rounded-full p-[2px] transition-colors duration-300 sm:h-[24px] sm:w-[44px]',
                    isOn ? 'bg-[#6038FF]' : 'bg-[#CBCDD0]',
                    disabled && 'bg-[#BFAFFF]',
                )}
                onClick={toggleSwitch}
            >
                <div
                    className={clsx(
                        'h-[16px] w-[16px] transform rounded-full bg-white transition-transform duration-300 sm:h-[20px] sm:w-[20px]',
                        isOn ? 'translate-x-[20px]' : 'translate-x-[0px]',
                    )}
                ></div>
            </button>
        </div>
    );
};

export default Switch;
